/**
 * Merge product query params (source, returnUrl) into a URLSearchParams instance.
 * @param {{ source?: string, returnUrl?: string|null }} product
 * @param {URLSearchParams|Record<string, string>|undefined} extra
 * @returns {URLSearchParams}
 */
export const withProductParams = (product, extra) => {
  const params =
    extra instanceof URLSearchParams ? new URLSearchParams(extra) : new URLSearchParams(extra || {})

  if (product?.source) {
    params.set('source', product.source)
  }

  if (product?.returnUrl) {
    params.set('returnUrl', product.returnUrl)
  } else {
    params.delete('returnUrl')
  }

  return params
}
